import { render, staticRenderFns } from "./collectionEvent.vue?vue&type=template&id=2e3f618e"
import script from "./collectionEvent.vue?vue&type=script&lang=js"
export * from "./collectionEvent.vue?vue&type=script&lang=js"
import style0 from "./collectionEvent.vue?vue&type=style&index=0&id=2e3f618e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports